export default "__VITE_ASSET__0be27ffe__"